import axios from 'axios'
import { trackPromise } from 'react-promise-tracker';
import * as CommonVariables from '../../Common/CommonVariables'

export const GetUserDetailById = async (userId) => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `User/GetUserById?userId=${userId}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const UpdateUserDetail = async (userEmail,userPassword) => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `User/UpdateUserDetail?userEmail=${userEmail}&userPassword=${userPassword}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const GetUserDependedFeildDataList = async () => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `User/GetUserDependedFeildDataList`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const CreateUser = async (userData) => {
    //debugger;
    //console.log(JSON.stringify(userData))
    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `User/SaveUser`, JSON.stringify(userData), CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const UpdateUser = async (userData) => {
    //debugger;
    //console.log(userData)
    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `User/UpdateUser`, JSON.stringify(userData), CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const GetUniversalFilterUserData = async (searchData) => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `User/GetUniversalFilterUserListData?searchdata=${searchData}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}
export const ActivateDeactivateUser = async (Id,IsActive) => {
    
    const response = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `User/ActivateDeactivateUserDetail?id=${Id}&isActive=${IsActive}`, CommonVariables.API_HEADER))
        .then(response => response);
    return response;
}

export const GetAccessControlMasterList = async (userid, partnerCode) => {
  //debugger;
  const url = userid != null
    ? `${CommonVariables.API_DOMAIN}User/GetAccessControlMasterList?userid=${userid}&partner_code=${partnerCode}`
    : `${CommonVariables.API_DOMAIN}User/GetAccessControlMasterList?partner_code=${partnerCode}`;

  const result = await trackPromise(
    axios.get(url, CommonVariables.API_HEADER)
  ).then(response => response);

  return result;
};

export const GetAccessControlMasterList_ForPartnerAdmin = async (userid) => {
  const url = userid != null
    ? `${CommonVariables.API_DOMAIN}User/GetAccessControlMasterList_ForPartnerAdmin?userid=${userid}`
    : `${CommonVariables.API_DOMAIN}User/GetAccessControlMasterList_ForPartnerAdmin`;

  const result = await trackPromise(
    axios.get(url, CommonVariables.API_HEADER)
  ).then(response => response);

  return result;
};

export const ValidateCrossUser = async (payload) => {
    //debugger;
    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `User/ValidateCrossUser`, JSON.stringify(payload), CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const ValidateSalesAdminSwitchUserLogin = async (payload) => {
    //debugger;
    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `User/ValidateSalesAdminSwitchUserLogin`, JSON.stringify(payload), CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const GetRoleAccessMappingByRoleId = async (roleId) => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `User/GetRoleAccessMappingByRoleId?roleId=${roleId}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const GetUniversalRoleAccessMapping = async () => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `User/GetRoleUserAccessMapping`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const AddRoleAccessMapping = async (payload) => {
    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `User/AddRoleUserAccessMapping`, payload, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const ActivateDeActivateUserAccessTemplate = async(Id, IsActive) => {
    //debugger;
    var result = await trackPromise(
        axios.get(CommonVariables.API_DOMAIN + `User/ActivateDeActivateUserAccessTemplate?mappingid=${Id}&isActive=${IsActive}`),
        CommonVariables.API_HEADER
    ).then(response => response)
    return result;
}